<div class="body">
  <app-header></app-header>
    <mat-sidenav-container class="side-menu-sidenav-container">
      <!-- [ngClass]="{ 'no-scroll': showSubMenu }" -->
      <mat-sidenav-content>
        <mat-drawer-container class="example-container" [hasBackdrop]="true">
          <mat-drawer-content>
            
           
            
            <router-outlet class="router"></router-outlet>
          </mat-drawer-content>
            </mat-drawer-container>
      </mat-sidenav-content>
    </mat-sidenav-container>
    
    <app-footer></app-footer>
</div>